import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { Icon, Surface, TextBody } from '../../atoms';
import { useBreakpoints } from '../../hooks';
export const ContentCard = memo(({ icon, label, description }) => {
    const { breakpoints } = useBreakpoints(500);
    return (_jsxs(Surface, { variant: "tertiary", style: StyleSheet.flatten([
            $.container,
            breakpoints.LESS_THAN_S && $.container_S,
            breakpoints.LESS_THAN_M && $.container_M,
        ]), children: [_jsx(View, { style: $.iconWrapper, children: _jsx(Icon, { name: icon, size: 16, color: "primary" }) }), _jsx(TextBody, { em: true, color: "primary", center: true, style: [$.label, breakpoints.LESS_THAN_S && $.label_S], children: label }), _jsx(TextBody, { style: $.description, center: true, children: description })] }));
});
const $ = StyleSheet.create({
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.radius.md,
        minWidth: 320,
        height: 212,
    },
    container_M: {
        padding: theme.spacing['4'],
        borderRadius: theme.radius.sm,
    },
    container_S: {
        height: 184,
    },
    iconWrapper: {
        width: 32,
        height: 32,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.color.background.white,
        borderRadius: theme.radius.sm,
        borderWidth: 1,
        borderColor: theme.color.border.primary,
    },
    label: {
        marginTop: theme.spacing['6'],
    },
    label_S: {
        marginTop: theme.spacing['4'],
    },
    description: {
        marginTop: theme.spacing['1'],
    },
});
